<!--
  ~ Copyright (c) 2026. Slimme Infrasoftware B.V. Apeldoorn /
  ~ Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden
  ~ volgens de voorwaarden die zijn vastgelegd in de overeenkomst
  ~ tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
  ~ overeenkomsten tussen Slimme Infrasoftware B.V en
  ~ Spin in het Web B.V.
  -->

<div class="head">
    <h1 *ngIf="isNieuw">Nieuw project</h1>
    <h1 *ngIf="! isNieuw">{{ record?.label }} ({{ record?.bron }})</h1>
</div>
<div class="content">
    <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
            <a class="nav-link active" [id]="id('basistab')" data-toggle="tab" role="tab"
               [attr.aria-controls]="id('basis')"
               aria-selected="true"
               [href]="hashid('basis')">Basisgegevens</a>
        </li>
        <li class="nav-item">
            <a class="nav-link" [id]="id('functietab')" data-toggle="tab" role="tab"
               [attr.aria-controls]="id('functies')" aria-selected="false"
               [href]="hashid('functies')"><span class="fas fa-exclamation-triangle text-warning"
                                                 *ngIf="this.record.kritiekPerCat.functies"
                                                 title="Er zijn problemen met functies in dit project"></span> Functies</a>
        </li>
    </ul>
    <div class="tab-content mt-2">
        <div class="tab-pane fade show active" [id]="id('basis')" role="tabpanel"
             [attr.aria-labelledby]="id('basistab')">
            <div class="alert alert-warning" role="alert" *ngIf="record?.kritiek?.length">
                <p *ngFor="let regel of record.kritiek">{{ regel }}</p>
            </div>
            <form #form='ngForm' autocomplete="off">
                <div class="form-row">
                    <!-- <comment>Wat hier naam heet, is in exact de unieke code. Wat we als naam beschouwen, is in exact de
                       omschrijving. Wij volgende de veldnamen van exact
                     </comment>-->
                    <div class="w-col-lg-6">
                        <div class="form-group">
                            <label [for]="id('naam')">Naam</label>
                            <input type="text" [id]="id('naam')" name="naam" autofocus class="form-control"
                                   minlength="1" maxlength="98" required
                                   [readonly]="readonly || record.bron === 'Exact'"
                                   [(ngModel)]="record.omschrijving" spellcheck="false">
                        </div>
                    </div>
                    <div class="w-col-lg-6">
                        <div class="form-group">
                            <label [for]="id('code')">Code</label>
                            <input type="text" [id]="id('code')" name="code" autofocus class="form-control"
                                   minlength="1" maxlength="30" required
                                   [readonly]="readonly || record.bron === 'Exact'"
                                   [(ngModel)]="record.naam" spellcheck="false">
                        </div>
                    </div>
                    <div class="w-col-lg-6">
                        <div class="form-group">
                            <label [for]="id('klant')">Klant</label>
                            <input type="text" [id]="id('klant')" name="klant" autofocus class="form-control"
                                   minlength="1" maxlength="98" required
                                   [readonly]="readonly || record.bron === 'Exact'"
                                   [(ngModel)]="record.klantnaam" spellcheck="false">
                        </div>
                    </div>
                    @if (api.can('project', 'read')) {
                        <div class="w-col-lg-6">
                            <div class="form-group">
                                <label [for]="id('externe_wm')">Externe werkmaatschappij <span class="inforondje"
                                                                                               title="Hiermee geef je aan dat dit een project voor diensten van een andere ATR-werkmaatschappij is. Op dit project zie je dan de diensten uit die werkmaatschappij, waarop wij mensen mogen plannen en waarop de uren uiteindelijk worden geschreven en gefactureerd. De bedoeling is dat dit project in Exact goed gekoppeld is aan de andere werkmaatschappij als klant, met de juiste functies in de WBS."></span></label>
                                <select [id]="id('externe_wm')" name="externe_werkmaatschappij" class="form-control"
                                        [(ngModel)]="record.externe_werkmaatschappij" [disabled]="readonly">
                                    <option [ngValue]="null"></option>
                                    @if (lookups.werkmaatschappij) {
                                        @for (wm of externeWerkmaatschappijen; track wm.id) {
                                            <option [ngValue]="wm.id">
                                                {{ wm.naam }}
                                            </option>
                                        }
                                    }
                                </select>
                            </div>
                        </div>
                    }
                    <div class="w-col-3 w-col-md-2">
                        <div class="form-group">
                            <label [for]="id('begindatum')">Begindatum</label>
                            <sihwdatepicker class="form-control" [id]="id('begindatum')"
                                            required
                                            name="begindatum" placeholder="dd-mm-jjjj"
                                            [(ngModel)]="record.begindatum" [bsConfig]="datepickerconfig"
                                            [disabled]="readonly || record.bron === 'Exact'"
                            ></sihwdatepicker>
                        </div>
                    </div>
                    <div class="w-col-3 w-col-md-2">
                        <div class="form-group">
                            <label [for]="id('einddatum')">Einddatum</label>
                            <sihwdatepicker class="form-control" [id]="id('einddatum')"
                                            name="einddatum" placeholder="dd-mm-jjjj"
                                            [(ngModel)]="record.einddatum" [bsConfig]="datepickerconfig"
                                            [disabled]="readonly || record.bron === 'Exact'"
                            ></sihwdatepicker>
                        </div>
                    </div>
                    @if (!record.externe_werkmaatschappij) {
                        <div class="w-col-6 w-col-md-8">
                            <div class="form-group">
                                <label [for]="id('locatie')">Locatie</label>
                                <input type="text" [id]="id('locatie')" name="locatie" class="form-control"
                                       minlength="1" maxlength="98" [required]="record.bron !== 'Exact'"
                                       [readonly]="readonly"
                                       [(ngModel)]="record.locatie" spellcheck="false">
                            </div>
                        </div>
                        <div class="w-col-sm-6">
                            <div class="form-group">
                                <label [for]="id('elementnummer')">WBS elementnummer</label>
                                <input type="text" [id]="id('elementnummer')" name="elementnummer" class="form-control"
                                       minlength="1" maxlength="40" [readonly]="readonly"
                                       [(ngModel)]="record.elementnummer">
                            </div>
                        </div>

                        <div class="w-col-sm-6">
                            <div class="form-group">
                                <label [for]="id('werkorder')">Werkorder</label>
                                <input type="text" [id]="id('werkorder')" name="werkorder" class="form-control"
                                       minlength="1" maxlength="48" [readonly]="readonly"
                                       [(ngModel)]="record.werkorder" spellcheck="false">
                            </div>
                        </div>
                        <div class="w-col-md-6">
                            <div class="form-group">
                                <label [for]="id('projectleider')">Projectleider</label>
                                <input type="text" [id]="id('projectleider')" name="projectleider" class="form-control"
                                       maxlength="150" [readonly]="readonly || record.bron === 'Exact'"
                                       [(ngModel)]="record.projectleider" spellcheck="false">
                            </div>
                        </div>
                        <div class="w-col-md-6">
                            <div class="form-group">
                                <label [for]="id('uitvoerder')">Uitvoerder</label>
                                <div class="input-group">
                                    <select [id]="id('uitvoerder')" name="uitvoerder" class="form-control"
                                            [disabled]="readonly"
                                            [(ngModel)]="record.uitvoerder_id" spellcheck="false">
                                        <option [ngValue]="null"></option>
                                        <ng-container *ngFor="let uvoerder of wmGebruikers">
                                            <option *ngIf="uvoerder.actief || (record?.orig('uitvoerder_id') === uvoerder.id)"
                                                    [ngValue]="uvoerder.id">{{ uvoerder.naam }}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="w-col-md-6">
                            <div class="form-group">
                                <label [for]="id('werkvoorbereider')">Werkvoorbereider</label>
                                <div class="input-group">
                                    <select [id]="id('werkvoorbereider')" name="werkvoorbereider" class="form-control"
                                            [disabled]="readonly"
                                            [(ngModel)]="record.werkvoorbereider_id" spellcheck="false">
                                        <option [ngValue]="null"></option>
                                        <ng-container *ngFor="let wvbereider of wmGebruikers">
                                            <option *ngIf="wvbereider.actief || (record?.orig('werkvoorbereider_id') === wvbereider.id)"
                                                    [ngValue]="wvbereider.id">{{ wvbereider.naam }}
                                            </option>
                                        </ng-container>
                                    </select>
                                </div>
                            </div>
                        </div>
                    }
                    <div class="w-col-lg-6">
                        <div class="form-group">
                            <label [for]="id('opmerkingen')">Overige gegevens</label>
                            <textarea class="form-control" [id]="id('opmerkingen')" name="opmerkingen"
                                      [(ngModel)]="record.opmerkingen"
                                      [readonly]="readonly || record.bron === 'Exact'"></textarea>
                        </div>
                    </div>
                    <div class="w-col-lg-6">
                        <div class="form-group">
                            <label [for]="id('factureerbaar')">Factureerbaar</label>
                            <select [id]="id('factureerbaar')" name="factureerbaar" class="form-control" required
                                    [(ngModel)]="record.factureerbaar" [disabled]="readonly">
                                <option [ngValue]="true">Ja</option>
                                <option [ngValue]="false">Nee</option>
                            </select>
                        </div>
                    </div>
                    <div class="w-col-lg-6" *ngIf="! readonly">
                        <div class="form-group">
                            <label [for]="id('kleur')">Kleur</label>
                            <div [id]="id('kleur')" [(colorPicker)]="record.kleur" [cpToggle]="true"
                                 cpFallbackColor="#FFFFFF" cpDialogDisplay="inline"
                                 [cpDisableInput]="true" cpWidth="382"
                                 cpAlphaChannel="disabled" cpOutputFormat="hex"
                                 (colorPickerChange)="form.form.markAsDirty()">
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="tab-pane fade show" [id]="id('functies')" role="tabpanel"
             [attr.aria-labelledby]="id('functietab')">
            <!--<comment>Standaardfuncties bij het project</comment>-->
            <div class="alert alert-warning" role="alert" *ngIf="record?.kritiekPerCat.functies?.length">
                <p *ngFor="let regel of record.kritiekPerCat.functies">{{ regel }}</p>
            </div>
            <h4>Functies<sup><span class="fas fa-question-circle"
                                   title="Deze functies zijn beschikbaar bij het project. Ze komen uit de WBS."></span></sup>
            </h4>

            <div *ngIf="lookups.functie">
                <ng-container *ngFor="let f of lookups.functie">
                    <div class="select-pill select" *ngIf="record.heeftStandaardfunctie(f.id)">{{ functienaam(f.id) }}
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<div class="foot">
    <div class="buttons" links>
        <button class="btn btn-secondary" (click)="closeWindow()">Annuleren</button>
        <button class="btn btn-danger" (click)="delete()" *ngIf="! readonly && ! isNieuw && record.bron !== 'Exact'"
                [disabled]="! canDelete"
                [attr.title]="canDelete? 'Verwijder dit project' : 'Dit project kan niet verwijderd worden, omdat ernaar wordt verwezen. Wel kan het inactief gemaakt worden.'">
            Verwijderen
        </button>
    </div>
    <div class="buttons" rechts>
        <button class="btn btn-primary" (click)="save()" *ngIf="! (readonly || shouldReload)"
                [disabled]=" form.invalid || form.pristine">
            Opslaan
        </button>
        <button class="btn btn-warning" (click)="reload()" *ngIf="shouldReload">Herladen (gewijzigd)</button>
    </div>
</div>
